<template>
  <div id="zhyq">
		<div style="display: flex;flex-direction: row;">
			<div class="item-left">
				<div class="item item1">
					<div style="width:30%;">
						<h3 style="text-align: left;color: #11c9fd;">设备运行</h3>
						<div id="pie1" style="width:200px;height: 200px;"></div>
					</div>
					<div style="width: 35%;display: flex;flex-direction: column;position: relative;top: -3%;">
						<div class="item-pie">
							<div id="pie2" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>视频监控</span>
							</p>
						</div>
						<div class="item-pie">
							<div id="pie3" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>门禁通道</span>
							</p>
						</div>
						<div class="item-pie">
							<div id="pie4" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>防盗报警</span>
							</p>
						</div>
					</div>
					<div style="width: 35%;display: flex;flex-direction: column;position: relative;top: -3%;">
						<div class="item-pie">
							<div id="pie5" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>信息发布</span>
							</p>
						</div>
						<div class="item-pie">
							<div id="pie6" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>停车场道闸</span>
							</p>
						</div>
						<div class="item-pie">
							<div id="pie7" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>广播系统</span>
							</p>
						</div>
					</div>
				</div>
				<div class="item item2">
					<h3 style="text-align: left;color: #11c9fd;">设备维护</h3>
					<div style="display: flex;flex-direction: row;margin-left:40px;">
						<p style="border-right: 2px solid #002f6b;border-bottom: 2px solid #002f6b;padding: 10px;">
							<span>今日完成工单</span>
							<br>
							<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">15</span>
						</p>
						<p style="border-right: 2px solid #002f6b;border-bottom: 2px solid #002f6b;padding: 10px;">
							<span>本周完成工单</span>
							<br>
							<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">15</span>
						</p>
						<p style="border-bottom: 2px solid #002f6b;padding: 10px;">
							<span>当月完成工单</span>
							<br>
							<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">15</span>
						</p>
					</div>
					<div style="display: flex;flex-direction: row;margin-left:40px;">
						<p style="border-right: 2px solid #002f6b;padding: 10px;">
							<span>今日完成工单</span>
							<br>
							<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">15</span>
						</p>
						<p style="border-right: 2px solid #002f6b;padding: 10px;">
							<span>本周完成工单</span>
							<br>
							<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">15</span>
						</p>
						<p style="padding: 10px;">
							<span>当月完成工单</span>
							<br>
							<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">15</span>
						</p>
					</div>
				</div>
				<div class="item item3">
					<div id="line"></div>
				</div>
			</div>
			<div class="item-middle">
				<div class="item item1" style="display: block;">
					<h3>智慧园区数据总览</h3>
					<div>广州 晴天 28℃~34℃ {{today}}</div>
					<div>
						<img src="../../public/static/vince/images/hd.png" style="width: 100%;height: 350px;" alt="">
					</div>
				</div>
				<div class="item item2">
					<h3 style="text-align: left;color: #11c9fd;">设备维护</h3>
					<div style="display: flex;flex-direction: row;">
						<div style="display: flex;flex-direction: column;width: 33%;">
							<div style="border-bottom: 2px solid #002f6b;padding: 10px;">
								<div style="float: left;">
									<img src="../../public/static/vince/images/icon_61.png"
										style="width: 50px;height: 50px;border-radius: 50%;" alt="">
								</div>
								<div style="float: left;">
									<span>员工总数</span>
									<br>
									<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">105</span>
								</div>
							</div>
							<div style="padding: 10px;">
								<div style="float: left;">
									<img src="../../public/static/vince/images/icon_61.png"
										style="width: 50px;height: 50px;border-radius: 50%;" alt="">
								</div>
								<div style="float: left;">
									<span>企业人数</span>
									<br>
									<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">105</span>
								</div>
							</div>
						</div>
						<div style="width: 33%;">
							<div id="pie15" style="width:100%;height: 150px;"></div>
						</div>
						<div style="display: flex;flex-direction: column;width: 33%;">
							<div style="border-bottom: 2px solid #002f6b;padding: 10px;">
								<div style="float: left;">
									<img src="../../public/static/vince/images/icon_61.png"
										style="width: 50px;height: 50px;border-radius: 50%;" alt="">
								</div>
								<div style="float: left;">
									<span>单位总数</span>
									<br>
									<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">105</span>
								</div>
							</div>
							<div style="padding: 10px;">
								<div style="float: left;">
									<img src="../../public/static/vince/images/icon_61.png"
										style="width: 50px;height: 50px;border-radius: 50%;" alt="">
								</div>
								<div style="float: left;">
									<span>访客人数</span>
									<br>
									<span style="color: #ffaf35;font-size: 20px;line-height: 30px;">105</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="item item3">
					<div id="pie16"></div>
				</div>
			</div>
			<div class="item-right">
				<div class="item item1" style="display: flex;flex-direction: row;">
					<div style="width: 33.3%;display: flex;flex-direction: column;">
						<div class="r-itemPie">
							<div id="pie8" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>周界报警</span>
							</p>
						</div>
						<div class="r-itemPie">
							<div id="pie9" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>暖通空调</span>
							</p>
						</div>
					</div>
					<div style="width: 33.3%;display: flex;flex-direction: column;">
						<div class="r-itemPie">
							<div id="pie10" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>给排水</span>
							</p>
						</div>
						<div class="r-itemPie">
							<div id="pie11" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>智能照明</span>
							</p>
						</div>
					</div>
					<div style="width: 33.3%;display: flex;flex-direction: column;">
						<div class="r-itemPie">
							<div id="pie12" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>变配电</span>
							</p>
						</div>
						<div class="r-itemPie">
							<div id="pie13" style="width:120px;height: 120px;"></div>
							<p>
								<span>1/10</span>
								<br>
								<span>会议</span>
							</p>
						</div>
					</div>
				</div>
				<div class="item item2">
					<h3 style="text-align: left;color: #11c9fd;">楼宇管理</h3>
					<div id="pie18" style="width:100%;height: 150px;"></div>
				</div>
				<div class="item item3">
					<div id="line1" style="width:100%;height: 263px;"></div>
				</div>
			</div>
    </div>
  </div>
</template>
<script>
  import * as echarts from '../../public/static/echart/echarts';
  export default {
    data() {
      return {
        pieChart1: null,
        pieChart2: null,
        pieChart3: null,
        pieChart4: null,
        pieChart5: null,
        pieChart6: null,
        pieChart7: null,
        pieChart8: null,
        pieChart9: null,
        pieChart10: null,
        pieChart11: null,
        pieChart12: null,
        pieChart13: null,
        pieChart14: null,
        pieChart15: null,
        pieChart16: null,
        pieChart17: null,
        pieChart18: null,
        today: "",
      }
    },
    methods: {
      // 全屏显示没做
      async getTianQi() {
        //   没有做axios封装,这个暂时用不了
        var result = await $axios.get('http://wthrcdn.etouch.cn/weather_mini?city=广州')
        console.log(result)
      },
      initChart() {
		var _this = this;
        this.pieChart1 = echarts.init(document.getElementById('pie1'));
        this.pieChart2 = echarts.init(document.getElementById('pie2'));
        this.pieChart3 = echarts.init(document.getElementById('pie3'));
        this.pieChart4 = echarts.init(document.getElementById('pie4'));
        this.pieChart5 = echarts.init(document.getElementById('pie5'));
        this.pieChart6 = echarts.init(document.getElementById('pie6'));
        this.pieChart7 = echarts.init(document.getElementById('pie7'));
        this.pieChart8 = echarts.init(document.getElementById('pie8'));
        this.pieChart9 = echarts.init(document.getElementById('pie9'));
        this.pieChart10 = echarts.init(document.getElementById('pie10'));
        this.pieChart11 = echarts.init(document.getElementById('pie11'));
        this.pieChart12 = echarts.init(document.getElementById('pie12'));
        this.pieChart13 = echarts.init(document.getElementById('pie13'));
        this.pieChart14 = echarts.init(document.getElementById('line'));
        this.pieChart15 = echarts.init(document.getElementById('pie15'));
        this.pieChart16 = echarts.init(document.getElementById('pie16'));
        this.pieChart17 = echarts.init(document.getElementById('line1'));
        this.pieChart18 = echarts.init(document.getElementById('pie18'));
        var option2 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical', // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
            x: 'right', // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
            y: 'center', // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
            itemWidth: 16, // 设置图例图形的宽
            itemHeight: 18, // 设置图例图形的高
            textStyle: {
              color: '#fff' // 图例文字颜色
            },
            itemGap: 10,
            // data: ['正常', '故障']
          },
          series: [{
            name: '设备运行',
            type: 'pie',
            // radius: '50%', // 设置饼状图大小，100%时，最大直径=整个图形的min(宽，高) --实心
            radius: ['35%', '55%'], // 设置环形饼状图， 第一个百分数设置内圈大小，第二个百分数设置外圈大小
            center: ['35%', '50%'], // 设置饼状图位置，第一个百分数调水平位置，第二个百分数调垂直位置 --空心
            data: [{
                value: 1642,
                name: '正常',
                itemStyle: {
                  normal: {
                    color: '#01e7fe', //改变折线点的颜色
                    lineStyle: {
                      color: '#01e7fe' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 310,
                name: '故障',
                itemStyle: {
                  normal: {
                    color: '#ff4e72', //改变折线点的颜色
                    lineStyle: {
                      color: '#ff4e72' //改变折线颜色
                    }
                  }
                },
              },
            ],

            itemStyle: { // itemStyle 设置饼状图扇形区域样式
              // emphasis：设置鼠标放到哪一块扇形上面的时候，扇形样式、阴影
              emphasis: { // emphasis：英文意思是 强调;着重;（轮廓、图形等的）鲜明;突出，重读
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(30, 144, 255，0.5)'
              }
            },
            labelLine: { // 设置值域的那指向线
              normal: {
                show: false // show设置线是否显示，默认为true，可选值：true ¦ false
              }
            },
            label: { // 设置值域的标签
              normal: {
                position: 'inner', // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: ''
              }
            }
          }]
        }
        var option3 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical', // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
            x: 'right', // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
            y: 'center', // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
            itemWidth: 16, // 设置图例图形的宽
            itemHeight: 18, // 设置图例图形的高
            textStyle: {
              color: '#fff' // 图例文字颜色
            },
            itemGap: 10,
            // data: ['正常', '故障']
          },
          series: [{
            name: '设备运行',
            type: 'pie',
            // radius: '50%', // 设置饼状图大小，100%时，最大直径=整个图形的min(宽，高) --实心
            radius: ['35%', '55%'], // 设置环形饼状图， 第一个百分数设置内圈大小，第二个百分数设置外圈大小
            center: ['35%', '50%'], // 设置饼状图位置，第一个百分数调水平位置，第二个百分数调垂直位置 --空心
            data: [{
                value: 1642,
                name: '正常',
                itemStyle: {
                  normal: {
                    color: '#01e7fe', //改变折线点的颜色
                    lineStyle: {
                      color: '#01e7fe' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 310,
                name: '故障',
                itemStyle: {
                  normal: {
                    color: '#ff4e72', //改变折线点的颜色
                    lineStyle: {
                      color: '#ff4e72' //改变折线颜色
                    }
                  }
                },
              },
            ],

            itemStyle: { // itemStyle 设置饼状图扇形区域样式
              // emphasis：设置鼠标放到哪一块扇形上面的时候，扇形样式、阴影
              emphasis: { // emphasis：英文意思是 强调;着重;（轮廓、图形等的）鲜明;突出，重读
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(30, 144, 255，0.5)'
              }
            },
            labelLine: { // 设置值域的那指向线
              normal: {
                show: false // show设置线是否显示，默认为true，可选值：true ¦ false
              }
            },
            label: { // 设置值域的标签
              normal: {
                position: 'inner', // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{d}%'
              }
            }
          }]
        }
        var option1 = {
          title: {
            text: '用气统计',
            textStyle: {
              color: "#11c9fd"
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '10%',
            top: '12%',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          series: [{
            name: '今日',
            type: 'line',
            itemStyle: {
              normal: {
                color: '#0688b8', //改变折线点的颜色
                lineStyle: {
                  color: '#0688b8' //改变折线颜色
                }
              }
            },
            areaStyle: {
              normal: {
                color: '#035d7f' //改变区域颜色
              }
            },
            data: [1, 5, 4, 8, 9, 3, 8, 5, 4, 7, 2, 3]
          }, ]
        };
        var option4 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical', // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
            x: 'right', // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
            y: 'center', // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
            itemWidth: 16, // 设置图例图形的宽
            itemHeight: 18, // 设置图例图形的高
            textStyle: {
              color: '#fff' // 图例文字颜色
            },
            itemGap: 10,
            // data: ['正常', '故障']
          },
          series: [{
            type: 'pie',
            // radius: '50%', // 设置饼状图大小，100%时，最大直径=整个图形的min(宽，高) --实心
            radius: ['40%', '50%'], // 设置环形饼状图， 第一个百分数设置内圈大小，第二个百分数设置外圈大小
            center: ['50%', '50%'], // 设置饼状图位置，第一个百分数调水平位置，第二个百分数调垂直位置 --空心
            data: [{
                value: 820,
                name: '员工总数',
                itemStyle: {
                  normal: {
                    color: '#01e7fe', //改变折线点的颜色
                    lineStyle: {
                      color: '#01e7fe' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 502,
                name: '企业人数',
                itemStyle: {
                  normal: {
                    color: '#fbb232', //改变折线点的颜色
                    lineStyle: {
                      color: '#fbb232' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 18,
                name: '单位总数',
                itemStyle: {
                  normal: {
                    color: '#ff4e72', //改变折线点的颜色
                    lineStyle: {
                      color: '#ff4e72' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 37,
                name: '访客人数',
                itemStyle: {
                  normal: {
                    color: '#02d9b8', //改变折线点的颜色
                    lineStyle: {
                      color: '#02d9b8' //改变折线颜色
                    }
                  }
                },
              },
            ],

            itemStyle: { // itemStyle 设置饼状图扇形区域样式
              // emphasis：设置鼠标放到哪一块扇形上面的时候，扇形样式、阴影
              emphasis: { // emphasis：英文意思是 强调;着重;（轮廓、图形等的）鲜明;突出，重读
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(30, 144, 255，0.5)'
              }
            },
            labelLine: { // 设置值域的那指向线
              normal: {
                show: false // show设置线是否显示，默认为true，可选值：true ¦ false
              }
            },
            label: { // 设置值域的标签
              normal: {
                position: 'inner', // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: ''
              }
            }
          }]
        }
        var option5 = {
          title: {
            text: '车位占用情况',
            textStyle: {
              color: "#11c9fd"
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '15%',
            top: '20%',
          },
          xAxis: {
            type: 'category',
            data: ['科研楼', '公寓楼', '信息中心', '办公楼', '综合楼'],
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          series: [{
            // name: '今日',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#0688b8', //改变折线点的颜色
                lineStyle: {
                  color: '#0688b8' //改变折线颜色
                }
              }
            },
            areaStyle: {
              normal: {
                color: '#035d7f' //改变区域颜色
              }
            },
            data: [5, 4, 8, 9, 3]
          }, ]
        };
        var option6 = {
          title: {
            text: '水电统计',
            textStyle: {
              color: "#11c9fd"
            }
          },
          legend: {
            data: ['用电统计', '用水统计'],
            textStyle: {
              color: "#fff"
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '6%',
            right: '4%',
            bottom: '10%',
            top: '12%',
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          series: [{
              name: '用电统计',
              type: 'line',
              itemStyle: {
                normal: {
                  color: '#ff8762', //改变折线点的颜色
                  lineStyle: {
                    color: '#ff8762' //改变折线颜色
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: '#660066' //改变区域颜色
                }
              },
              data: [16, 23, 22, 24, 27, 32, 28, 25, 24, 27, 22, 20]
            },
            {
              name: '用水统计',
              type: 'line',
              areaStyle: {
                normal: {
                  color: '#8cd5c2' //改变区域颜色
                }
              },
              data: [26, 25, 24, 28, 29, 30, 28, 25, 24, 27, 22, 20]
            },
          ]
        };
        var option7 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            textStyle: {
              color: '#fff' // 图例文字颜色
            },
            data: ['科研楼', '公寓楼', '信息中心', '办公室', '综合楼']
          },
          series: [{
            name: '访问来源',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [{
                value: 335,
                name: '科研楼'
              },
              {
                value: 310,
                name: '公寓楼'
              },
              {
                value: 234,
                name: '信息中心'
              },
              {
                value: 135,
                name: '办公室'
              },
              {
                value: 1548,
                name: '综合楼'
              }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        };
        this.pieChart1.setOption(option3, true);
        this.pieChart2.setOption(option2, true);
        this.pieChart3.setOption(option2, true);
        this.pieChart4.setOption(option2, true);
        this.pieChart5.setOption(option2, true);
        this.pieChart6.setOption(option2, true);
        this.pieChart7.setOption(option2, true);
        this.pieChart8.setOption(option2, true);
        this.pieChart9.setOption(option2, true);
        this.pieChart10.setOption(option2, true);
        this.pieChart11.setOption(option2, true);
        this.pieChart12.setOption(option2, true);
        this.pieChart13.setOption(option2, true);
        this.pieChart14.setOption(option1, true);
        this.pieChart15.setOption(option4, true);
        this.pieChart16.setOption(option5, true);
        this.pieChart17.setOption(option6, true);
        this.pieChart18.setOption(option7, true);
			window.addEventListener("resize", function(){
				_this.pieChart1.resize();
				_this.pieChart2.resize();
				_this.pieChart3.resize();
				_this.pieChart4.resize();
				_this.pieChart5.resize();
				_this.pieChart6.resize();
				_this.pieChart7.resize();
				_this.pieChart8.resize();
				_this.pieChart9.resize();
				_this.pieChart10.resize();
				_this.pieChart11.resize();
				_this.pieChart12.resize();
				_this.pieChart13.resize();
				_this.pieChart14.resize();
				_this.pieChart15.resize();
				_this.pieChart16.resize();
				_this.pieChart17.resize();
				_this.pieChart18.resize();
			});
      },

    },
    mounted() {
      this.initChart();
      this.countDown = setInterval(() => {
        this.today = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000)
      //   this.getTianQi();
      //   this.byHeight = document.documentElement.clientHeight - 100
	},
    beforeDestroy() {
      //清除定时器
      clearInterval(this.countDown);
    },
  }

</script>
<style scoped>
	#pie1>div{
		width: 130px;
	}
	#pie2>div{
		width: 80px;
		height: 100px;
		left: 50%;
		transform: translateX(-50%);
	}
	.item-left,
	.item-middle {
		width: 37%;
	}

	.item-right {
		width: 26%;
	}

	.item {
		box-sizing: border-box;
		border: 1px solid #2f5b9a;
		margin: 10px 5px 5px 10px;
		padding: 5px;
	}
	.item:hover{
		box-shadow: #6273b5 0px 0px 2px 2px;
	}
	.item-pie{
		height: 33%;
	}
	.item-pie>div{
		width: 120px;
		height: 120px;
		top: -10%;
		left: 50%;
		transform: translateX(-38%);
		position: relative;
	}
	.item-pie>p{
		position: relative;
		top: -30%;
		left: 50%;
		transform: translateX(-50%);
	}
	.item1{
		height: 400px;
		display: flex;
		flex-direction: row;
		overflow: hidden;
	}
	.item2{
		height: 210px;
	}
	.item3{
		height: 300px;
	}
	#line{
		width:100%;
		height: 270px;
	}
	#line1{
		width:100%;
		height: 300px;
	}
	#pie16{
		width:100%;
		height: 300px;
	}
	.b-top {
		/*x轴偏移 y轴偏移 虚化程度 阴影宽度 阴影颜色*/
		box-shadow: -10px 5px 10px 0 #042158, 10px 5px 10px 0 #0a2466;
	}
	.r-itemPie {
		display: flex;
		flex-direction: column;
		flex: 1;
		text-align: center;
	}
	.r-itemPie>div{
		left: 50%;
		transform: translateX(-37%);
	}
</style>
